import { SpecManager } from "./SpecManager";

import { uniq } from "lodash"

export default abstract class Spec {
    abstract value: string | number | boolean;

    // abstract displayValue: string | number | boolean;

    impacted: Spec[] = [];
    dependencies: { [k: string]: Spec } = {};

    toUpdate = false;

    _readonly: boolean = false;

    get readonly(): boolean {
        if (this.specManager.readonly) {
            return true;
        }
        return this._readonly;
    }

    set readonly(value: boolean) {
        this._readonly = value;
    }

    get displayValue() {
        if (typeof this.value === "number") {
            return Math.round(this.value)
        }
        return this.value
    }

    set displayValue(data) {
        // if (this.readonly) {
        //     return
        // }
        this.value = data
    }

    get uniqueKey() {
        return this.specManager.name + ":" + this.key
    }

    getDependencyKey(dependency:Spec, key) {
        if (key) {
            return key
        }
        if (!dependency) {
            debugger
            return ""
        }
        if (dependency.specManager.name == this.specManager.name) {
            return dependency.key
        }
        return dependency.uniqueKey
    }

    constructor(public specManager: SpecManager, public key: string, readonly:boolean) {
       this._readonly = readonly || false
       this.specManager.specs.push(this)
    }

    onModified() {
        this.invalidate();
        this.toStream();
    }

    invalidate() {
        if (!this.toUpdate) {
            this.toUpdate = true;
            // this.build()
            for (const impacted of this.impacted) {
                impacted.invalidate();
            }
        } else {
            // debugger
        }
    }

    toStream() {
        this.specManager.toStream = true;
    }

    getKey(): string {
        return this.key;
    }

    static getDependencies(func: string) {
        if (!func) {
            return []
        }
        // const regex = /\[([A-Z]){2,3}(.\d{2})?]|\[N1:([A-Z]){2,3}]/g
        const regex = /\[([A-Z0-9:_@]{2,})\]/g
        // let rule = this.rules[field].function
        const matches = func.match(regex)
        if (matches) {
            const uniqMatches = uniq(matches)
            return uniqMatches.map(m => m.replace("[", "").replace("]", ""))
        } else if (func.includes("[") || func.includes("]")) {
            console.error("unsupported function func= ", func)
            debugger
        }
        return []
    }

    setDependencies(dependencies: Spec[], key = null) {
        // debugger
        // for (const dependency of dependencies) {
        //     const internalKey = this.getDependencyKey(dependency,  key)
        //     if (!internalKey) {
        //         debugger
        //         continue
        //     }
        //     this.dependencies[internalKey] = dependency;

        //     this.toUpdate = true
        //     dependency.addImpacted(this);
        // }
    }

    addImpacted(impacted: Spec) {
        let exist = this.impacted.includes(impacted);
        if (!exist) {
            this.impacted.push(impacted);
        }
    }

    update(used) {
        if (this.toUpdate) {
            if (used.length && used.indexOf(this.uniqueKey) !==-1) {
                // debugger
                // console.error(used.indexOf(logKey))
                console.error("already updated=", used.join(","))
                return
            }
            used.push(this.uniqueKey)
            // console.log(logKey)
            // debugger
            for (const key in this.dependencies) {
                const dependency = this.dependencies[key]
                dependency.update(used);
            }
            // for (const imp of this.impacted) {
            //     imp.update(used);
            // }
            this.build();
            this.toUpdate = false;

        }
    }

    isDefined(): boolean {
        return this.value !== undefined && this.value !== null && this.value !== "";
    }

    abstract build(): void;

    abstract setStream(stream: { userValue?: string | number | boolean; computedValue?: number })
    abstract getStreamValue(): { userValue?: string | number | boolean; computedValue?: string | number | boolean }

    getImpacted(): string[] {
        return this.impacted.map((spec) => spec.getKey());
    }

    static getValue(value) {
        if (!value) {
            debugger
            return 0
        }
        if (value.conditionValue !== undefined && value.conditionValue !== null) {
            if (value.globalUserValue !== null && value.globalUserValue !== undefined) {
                return value.globalUserValue
            }
            return value.conditionValue ? value.aValue_ : value.bValue_
        }
        return (value.userValue !== undefined && value.userValue !== null) ? value.userValue : value.computedValue
    }

    get originalValue():string | number | boolean {
        return 0.0
    }

    abstract resetOriginalValue()

    abstract get isUserValue():boolean

    forceUserValue(value: string | number | boolean) {
        const prevReadonly = this.readonly
        this.readonly = false
        this.value = value
        this.readonly = prevReadonly
    }
}
